module.exports = __webpack_public_path__ + "static/media/answer.ac87219e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/svg/answer.svg
// module id = 1412
// module chunks = 0